import axios from '@/http/axios/index.js'


export default {
    getPallets() {
        return axios.get('warehouse/pallets').then(res => res.data)
    },
    updatePallets(payload) {
        return axios.post('warehouse/pallets/update',payload).then(res => res.data)
    },
    getExpenses(payload) {
        return axios.get('warehouse/expenses/pallets/list', { params: payload }).then(res => res.data)
    },
    getExpense(payload) {
        return axios.get('warehouse/expenses/pallets/show', { params: payload }).then(res => res.data)
    },
    updateExpense(payload) {
        return axios.post('warehouse/expenses/pallets/update/items', payload).then(res => res.data)
    },
    approveExpense(payload) {
        return axios.post('warehouse/expenses/pallets/approved', payload).then(res => res.data)
    },
    deleteExpense(payload) {
        return axios.delete('warehouse/expenses/pallets/delete', { params: payload }).then(res => res.data)
    },
    getFiles(payload) {
        return axios.get('warehouse/expenses/pallets/files', { params: payload }).then(res => res.data)
    },


}